<template>
    <header class="navbar">
        <router-link :to="{ name: 'index', params: { locale: $i18n.locale() } }" class="brand">
            <img src="/img/villa-kanedolo-pijetao.svg" alt="">
        </router-link>

        <main-menu>
            <template slot="footer">
                <div class="lang-menu">
                    <a hreflang="en" :class="{ 'active': $i18n.locale() == 'en' }" href="#en" @click.prevent="setLocale('en')">en</a>
                    <a hreflang="hr" :class="{ 'active': $i18n.locale() == 'hr' }" href="#hr" @click.prevent="setLocale('hr')">hr</a>
                    <a hreflang="de" :class="{ 'active': $i18n.locale() == 'de' }" href="#de" @click.prevent="setLocale('de')">de</a>
                </div>
            </template>
        </main-menu>

        <nav class="side-menu">
            <dropdown-menu trigger-class="nav-item">
                <template slot="trigger">
                    <span class="uppercase">{{ $i18n.locale() }}</span>
                </template>
                <template slot="items">
                    <a class="dropdown-item uppercase" hreflang="en" :class="{ 'active': $i18n.locale() == 'en' }" href="#en" @click.prevent="setLocale('en')">en</a>
                    <a class="dropdown-item uppercase" hreflang="hr" :class="{ 'active': $i18n.locale() == 'hr' }" href="#hr" @click.prevent="setLocale('hr')">hr</a>
                    <a class="dropdown-item uppercase" hreflang="de" :class="{ 'active': $i18n.locale() == 'de' }" href="#de" @click.prevent="setLocale('de')">de</a>
                </template>
            </dropdown-menu>

            <a href="https://www.facebook.com/villakanedolo/" target="_blank" class="nav-item ml-base mr-1">
                <img src="/svg/facebook.svg" alt="">
            </a>

            <a href="#reviews" class="nav-item" data-scroll>
                <img src="/svg/star.svg" alt="" class="mr-1">
                <span class="text-xs">5.0</span>
            </a>
        </nav>

        <button type="button" class="main-menu-trigger ml-auto" :class="{ 'active': $store.state.mainMenu.status }" @click="toggleMainMenu">
            <span></span>
        </button>
    </header>
</template>

<script>
import MainMenu from './MainMenu.vue'

export default {
    components: {
        MainMenu
    },

    methods: {
        toggleMainMenu() {
            this.$store.state.mainMenu.status = !this.$store.state.mainMenu.status
        },

        setLocale(lang) {
            if (this.$store.state.langs.has(lang) === true) {
                this.$i18n.set(lang)

                router.push({ name: this.$route.name, params: { locale: lang } })
            }
        }
    }
}
</script>
